import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useLogoutMutation } from 'services/users';
import { useAppSelector } from 'app/hooks';
import { useGetUserDataQuery } from 'services/users';

import { StyledLinkList, StyledLink } from 'ui/navigation/StyledLinkList';
import { selectAccessToken } from 'features/users/usersSlice';
import { LanguageSelector } from 'components/reusable/languageSelector';


export const HomepageNavigation = () => {
  const { t } = useTranslation();
  const [logout, { isSuccess: isLoggedOut }] = useLogoutMutation();
  const navigate = useNavigate();
  const accessToken = useAppSelector(selectAccessToken);
  const { data: userData } = useGetUserDataQuery(undefined, { skip: !accessToken });

  useEffect(() => {
    if(isLoggedOut) {
      navigate('/');
    }
  }, [isLoggedOut, navigate, accessToken]);

  const submitLogout = () => {
    logout({});
  }

  return (
    <>
      <StyledLinkList align="left">
        <li>
          <a href="/#about">{t('About')}</a>
        </li>
        <li>
          <a href="/#features">{t('Features')}</a>
        </li>
        <li>
          <a href="/#cases">{t('Cases')}</a>
        </li>
        <li>
          <a href="pricing/">{t('Pricing')}</a>
        </li>
        <li>
          <a href="/#contact">{t('Contact')}</a>
        </li>
      </StyledLinkList>
      <StyledLinkList align="right">
        <LanguageSelector />
        <li>
          {userData?.id ? (
            <StyledLinkList align="right">
              <li>
              <StyledLink href="/backoffice/">
                {t('Backoffice')}
              </StyledLink>
              </li>
              <li>
              <StyledLink onClick={submitLogout}>
                {t('Logout')}
              </StyledLink>
              </li>
            </StyledLinkList>
          ) : (
            <StyledLink href="/sign-in/">
              {t('Sign in')}
            </StyledLink>
          )}
        </li>
      </StyledLinkList>
    </>
  );
}
